var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g3, _g4, _g5, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-sm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#19b6ef",
    d: "M0 255.999h512v255.999H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v255.999H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.86 361.822c55.944-41.854 116.22-127.256 45.588-172.166-13.158-2.548-27.846-1.784-34.893 3.82-3.734-2.123-6.707-1.953-10.441 2.038-2.632-3.227-5.265-4.671-10.698-3.056-10.866-5.519-20.713-6.707-33.617-3.312-61.463 36.929-23.856 124.54 44.06 172.676z",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 2.369,
    fill: "#fd0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#3a9d4f"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M356.335 266.768s6.296-8.467 6.513-8.467c6.297-3.692 6.949-8.468 6.949-8.468 6.296-1.955 4.342-7.166 4.775-7.816 3.042-3.257 1.955-6.515 1.521-7.6 0-.868 2.171-8.902-.869-9.987.144-8.541-5.138-7.745-9.336-2.172-4.488 1.303-5.5 4.995-3.909 9.12-5.863 0-6.08 8.468-4.342 13.244-7.816-.217-3.474 8.468-3.692 8.903-2.605 1.302 1.954 13.679 2.39 13.243zm-49.304 72.738l3.909 2.388c.796 2.967 3.546 4.85 5.646 4.344 1.013 4.56 5.934 3.91 9.554 1.303 2.894 4.198 6.442 4.27 11.29 2.823 4.343 3.184 9.99 1.809 13.68-1.521 3.98 3.257 6.658.869 8.684-2.605 3.11.796 5.572.29 6.73-2.823 6.08-.506 3.04-6.224-1.953-8.684 3.98-3.476 8.395-10.641 2.171-11.727-1.954-1.446-5.644-1.156-8.467.219-.723-3.186-5.14-3.982-9.989-.435-1.665-3.547-7.455-1.882-10.205.652-3.474-3.04-7.6-3.04-13.679.433l-17.37 15.633zm0-9.327c.723-3.98-2.027-11.218 2.171-11.941-.796-6.66.363-14.186 8.035-13.462 1.23-6.297.941-12.16 8.25-13.029 0 0 5.864-20.409 11.944-6.297 2.387 4.128 1.954 10.856-2.824 9.554.942 5.067-.723 9.48-6.296 9.336 2.46 3.547 1.664 8.397-1.086 10.64l-20.194 15.199zm35.392-25.407l6.297-1.302c6.513-4.343 9.12-6.08 12.376-1.304 5.428-1.159 10.639-.58 10.422 3.692 6.443.433 6.37 4.559 5.647 7.815 1.012 5.718-1.448 13.173-5.43 4.126-12.593-7.672-19.759-6.66-39.734-2.171 3.473-3.62 6.949-7.237 10.422-10.856zm3.269-6.307c.219-.217 18.673-4.995 16.719-10.64 5.211-.868 6.298-6.08 6.515-6.08 10.856-3.473 10.204-9.77 10.204-9.77 3.112-3.33 8.613-6.66 7.384-12.594.362-6.73.94-10.856-8.035-6.514-6.732-.652-9.12 3.257-11.074 9.12-3.184-3.763-8.322 2.244-8.901 7.6 0 0-8.251 8.033-8.251 8.25s-6.949 12.81-6.949 12.81l2.388 7.818z",
    fillRule: "evenodd",
    strokeWidth: 2.369,
    fill: "#4fd46b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M346.119 284.144c-4.416-3.33-6.876-7.309-6.08-11.29-2.895-3.91-4.922-6.297-2.171-9.77 0 0-2.172-7.818-2.172-8.035-5.644-2.17-3.256-6.947-1.737-8.684-2.678-3.692-2.75-7.601-.217-11.074-.073-6.95 4.849-4.343 8.901 0 0 0 6.732 4.777 1.738 9.12 4.994 1.737 6.515 6.077 3.692 7.815 4.342 1.954 4.992 5.863 2.605 8.47 4.415 3.546 2.75 7.961 4.125 11.94-2.894 3.837-5.79 7.673-8.684 11.508z",
    fillRule: "evenodd",
    strokeWidth: 2.369,
    fill: "#4fd46b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M353.936 251.79c-.217-.216-7.382-9.336-5.428-9.988-.433-2.823-2.604-5.863-1.302-8.684-3.546-3.547-3.62-7.743-.869-11.073-2.388-3.256-1.302-7.599 1.954-10.422-1.012-5.357 2.75-6.586 6.08-7.6 2.461-8.614 6.44-6.37 8.685.216 3.402 2.967 2.896 7.455 1.737 10.858 4.053 2.75 1.592 6.15-.216 7.599-3.547 9.699-7.095 19.396-10.641 29.095z",
    fillRule: "evenodd",
    strokeWidth: 2.369,
    fill: "#4fd46b"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M352.852 205.97l-6.08-6.08c1.571-3.221 2.836-8.9-1.735-11.508-2.522-6.14-15.127-13.752-17.154.869-1.92-4.412-5.935-8.757-8.902-3.69-6.586-5.645-10.132-3.909-6.732 3.256 0 0-3.038 4.776 4.995 8.468.652.65-2.605 8.685 6.948 8.901-1.808 2.75 1.159 6.587 4.995 6.297-2.75 3.402 1.881 7.022 4.775 5.646-1.23 3.763-1.158 5.574 4.126 6.08l5.863 6.73 4.776 6.514 4.125-31.483z",
    fillRule: "evenodd",
    strokeWidth: 2.369,
    fill: "#4fd46b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.548 262.93c.307-.307 11.667-26.406 13.202-34.39m-11.976-11.963s1.842 21.187-3.378 36.847m-31.623-58.346s23.337 22.415 25.485 31.628m-9.211-34.079s1.535 18.424 7.983 36.541m33.166 30.387s-23.337 19.652-34.7 36.847m12.58 31.947s-30.707 4.3-44.217 4.607m34.09 8.594s-38.077-.922-40.841-3.685m21.794-45.761c0 .306-19.344 32.24-19.96 42.682",
    strokeLinecap: "round",
    strokeWidth: 2.221,
    fill: "none"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.646 355.657c-40.285-37.999-81.548-109.312-40.501-145.35 7.295 4.138 15.896.435 27.764-4.247 3.593 3.92 8.164 4.9 12.737 1.96 5.117 2.178 8.928.435 11.433-2.287 11.65 6.752 26.566 10.236 30.05 3.595 40.393 38.323-.546 109.965-41.483 146.329z",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 2.369,
    fill: "#65c7ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.877 354.555c-17.3-17.394-33.084-36.676-45.169-61.502 2.068-1.741 3.03-2.281 4.119-5.33 6.206.872 9.471 1.089 17.637-.327 1.633 6.097 1.96 11.214 5.88 16.331l8.165-16.004c5.552 1.307 12.412 1.634 17.637 0 3.376 4.573 2.178 11.433 8.166 16.658 3.592-10.56 7.187-11.323 10.78-16.985 5.334 1.851 8.71 1.089 13.065-.327 2.287 2.613 1.144 2.57 5.307 6.407-10.914 21.674-25.881 43.442-45.587 61.08z",
    fillRule: "evenodd",
    fill: "#8fc753"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.48 175.248a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm-3.724-8.224a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm-4.346-7.604a3.569 3.569 0 1 1-7.137 0 3.569 3.569 0 0 1 7.138 0zm-2.947-7.448a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm.465-8.068a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm18.839-13.344a3.569 3.569 0 1 1-7.137 0 3.569 3.569 0 0 1 7.137 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.11,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.721 131.801a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm-7.758 4.655a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm23.896-5.742a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm9.931.776a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm8.844-.465a3.569 3.569 0 1 1-7.137 0 3.569 3.569 0 0 1 7.137 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.11,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25 125.33a9.155 9.155 0 1 1-18.309 0 9.155 9.155 0 0 1 18.31 0z",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 1.112,
    fill: "#fd0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.892 130.87a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm9.311.775a3.569 3.569 0 1 1-7.137 0 3.569 3.569 0 0 1 7.137 0zm8.999-.465a3.569 3.569 0 1 1-7.137 0 3.569 3.569 0 0 1 7.137 0zm7.603-.31a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm9.466 1.086a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm7.448 4.654a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.11,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.028 161.8c3.04 5.782 6.078 11.788 9.118 17.569h84.509l9.786-16.902c-5.709-3.928-9.637-6.968-17.792-5.115-4.596-6.597-9.637-7.857-17.124-7.116-2.224-2.297-4.226-3.706-8.007-4.225l-17.79.445c-4.671.444-8.23 4.002-8.452 4.002-7.562-.89-14.455-.668-16.234 6.672-6.893-1.706-11.786.15-18.014 4.67z",
    fillRule: "evenodd",
    stroke: "#ac0000",
    strokeWidth: 2.369,
    fill: "#e40000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.823 144.37a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm.62 8.379a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm-2.638 7.758a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm-3.259 6.362a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0zm-3.878 8.069a3.569 3.569 0 1 1-7.138 0 3.569 3.569 0 0 1 7.138 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.11,
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.722 164.71a5.276 5.276 0 1 1-10.552 0 5.276 5.276 0 0 1 10.552 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.111,
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M259.767 152.573a6.362 6.362 0 1 1-12.723 0 6.362 6.362 0 0 1 12.723 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.112,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.849 140.786a5.741 5.741 0 1 1-11.482 0 5.741 5.741 0 0 1 11.482 0z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.112,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.172 116.317c0-.987-.03-4.441.039-4.58l-3.81-.07.109-3.386 3.306-.039.04-2.96h4.688v2.713h3.701l-.076 3.603-3.842-.039-.03 4.828-4.125-.07z",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 1.11,
    fill: "#fd0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.716 179.372c-7.563-12.824-18.676-30.257-11.788-37.806 9.551-10.818 31.948-1.038 46.256-7.34 1.038 12.233-2.372 32.47 3.115 36.696-1.706 1.482-3.411 2.966-5.115 4.448-3.115-4.003-8.98-9.367-16.234.222-4.152-3.63-8.871-2.992-11.094 1.835-2.114.284-1.991 1.13-5.14 1.945zm85.46-.444c7.563-12.824 18.676-30.257 11.788-37.806-9.552-10.818-31.949-1.038-46.256-7.34-1.038 12.233 2.371 32.47-3.115 36.696l5.115 4.447c4.922-6.92 11.064-7.144 16.234.222 4.152-3.63 8.453-3.132 11.094 1.836 2.114.284 1.991 1.13 5.14 1.945z",
    stroke: "#fd0",
    strokeWidth: 3.331,
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M210.485 188.931c30.394-3.113 58.564-2.002 84.51 0 1.113-3.187 2.223-6.376 3.336-9.564-29.504-5.337-49.89-6.003-88.512-.666l.666 10.23z",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 2.369,
    fill: "#fd0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.715 351.321c.218-1.524.435-2.945.654-4.47 3.022.814 5.328.5 7.838-.428l2.614-3.921-1.96-2.285c-1.723.371-3.137 1.972-4.246 3.369-1.736.081-3.267-.757-4.9-1.084-.544-2.287-1.09-4.571-1.633-6.858-1.62-1.915-4.982-1.78-4.246 1.633l.327 2.613c.653 1.633.897 3.88 1.96 5.103v2.68l3.592 3.648zm1.297-19.508c-2.273 1.127-4.97-.833-7.839-1.96-2.614-.179-4.714 1.998-7.839 1.307.57-1.697 1.96-1.96 2.94-2.94-.717-4.407 1.633-5.88 2.287-5.88.652 0 3.266.654 3.266.654l2.613.327c1.525 2.83 3.662 5.355 4.572 8.492z",
    fillRule: "evenodd",
    fill: "#c76e2e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.483 390.48c7.537-12.236 60.008-36.808 109.248-89.866-50.12 48.26-81.446 60.106-122.463 89.571l13.215.295z",
    fillRule: "evenodd",
    stroke: "#e9bf00",
    strokeWidth: 2.369,
    fill: "#ffe100"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.617 334.052a3.82 3.82 0 1 1-7.64 0 3.82 3.82 0 0 1 7.64 0zm36.672-37.186a4.33 4.33 0 1 1-8.66 0 4.33 4.33 0 0 1 8.66 0zm12.229-31.584a3.82 3.82 0 1 1-7.64 0 3.82 3.82 0 0 1 7.64 0zm-11.981-40.995a3.82 3.82 0 1 1-7.64 0 3.82 3.82 0 0 1 7.64 0z",
    fillRule: "evenodd",
    stroke: "#68300e",
    strokeWidth: 1.11,
    fill: "#9d4916"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.386 287.556v-16.158l-1.643-1.368v-3.834l3.013-.273.547-18.075-1.917-1.096-.273-3.011s2.19.82 2.19.273.548-3.56.548-3.56-1.368-.274-1.368-.821 1.641-1.917 1.641-1.917-.82-.823-1.094-1.37-.821-3.012-.821-3.012l.82-3.013-.546-1.643-1.37-2.465 1.917-1.917s-.547-2.464-.547-3.011 1.368-2.738 1.641-3.013c.276-.274 2.466-3.286 2.466-3.286l4.655-1.096 5.478.823 3.011 1.917.548 4.928s-.548 3.012-.821 3.012-2.465 1.096-2.465 1.096-2.74.274-3.013 0 .823 3.287.823 3.287v3.285l-.274 4.108s0 1.917-.275 2.19c-.274.274-.821 1.097-.821 1.097l-.274 4.108 4.382 1.094-.274 2.466-3.013.274.549 16.704 4.381.821v4.657l-1.917 1.094-.547 16.705h-15.337zm66.556.284v-16.157l-1.644-1.368v-3.834l3.013-.274.548-18.074-1.917-1.097-.274-3.011s2.19.82 2.19.273.548-3.56.548-3.56-1.368-.274-1.368-.82 1.641-1.918 1.641-1.918-.82-.823-1.094-1.37-.82-3.011-.82-3.011l.82-3.014-.547-1.643-1.37-2.464 1.917-1.917s-.547-2.465-.547-3.012 1.368-2.738 1.641-3.013c.276-.274 2.466-3.285 2.466-3.285l4.655-1.097 5.478.823 3.012 1.917.547 4.929s-.547 3.011-.821 3.011-2.464 1.096-2.464 1.096-2.74.274-3.014 0 .823 3.287.823 3.287v3.285l-.274 4.108s0 1.917-.275 2.19c-.274.274-.82 1.097-.82 1.097l-.274 4.108 4.38 1.094-.273 2.466-3.013.274.549 16.704 4.381.821v4.657l-1.917 1.094-.547 16.705h-15.336zm-33.687.55v-16.157l-1.643-1.368v-3.834l3.013-.273.547-18.075-1.917-1.096-.273-3.011s2.19.82 2.19.273.548-3.56.548-3.56-1.368-.274-1.368-.821 1.641-1.917 1.641-1.917-.82-.823-1.094-1.37-.821-3.012-.821-3.012l.82-3.013-.546-1.643-1.37-2.465 1.917-1.917s-.547-2.464-.547-3.011 1.368-2.738 1.641-3.013c.276-.274 2.466-3.286 2.466-3.286l4.655-1.096 5.478.823 3.011 1.917.548 4.928s-.548 3.012-.821 3.012-2.465 1.096-2.465 1.096-2.74.274-3.013 0 .823 3.287.823 3.287v3.285l-.274 4.108s0 1.917-.275 2.19c-.274.274-.821 1.097-.821 1.097l-.274 4.108 4.382 1.094-.274 2.466-3.013.274.549 16.704 4.381.821v4.657l-1.917 1.094-.547 16.705h-15.337z",
    fillRule: "evenodd",
    stroke: "#a9a9a9",
    strokeWidth: 1.11,
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.437 287.45v-12.734h7.132v13.243l-7.132-.51zm33.615 1.012l.254-12.99h6.368v12.734l-6.622.256zm33.118-.249l-.51-12.224 6.878-.255v12.735l-6.368-.256zm-64.956-38.465h4.074v6.621h-4.074zm32.354.266h5.603v6.368h-5.603zm33.1.498h4.84v6.111h-4.84z",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.328 220.752c4.382 4.928 4.655 4.928 4.655 4.928m27.93-4.928c.82 1.641 2.19 5.202 3.834 5.476m31.22-4.658s1.37 3.833 3.287 4.38",
    stroke: "#a8a8a8",
    strokeWidth: 1.11,
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.673 206.947c12.812-4.142-2.993-12.425-5.618 0-4.145.67-4.681 3.745-13.641 2.41-21.667 35.307-5.618 92.283 57.778 151.266-113.55-96.632-67.404-168.107-35.96-165.411 17.102 1.169 8.475 22.502-2.559 11.735z",
    fillRule: "evenodd",
    fill: "#b97700"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M219.244 188.842s10.433 2.81 10.433 7.223m-.003-8.022s7.222 3.208 8.826 6.017m48.152-4.81s-9.23 1.206-11.235 4.013m-2.818-3.213s-5.215 4.414-4.815 5.617m3.624 13.643c-.803-.402-4.413-5.217-3.612-11.236m-31.708 8.038s2.407-2.81 2.407-8.026m14.453-2.013l.402 11.636m10.028-1.597c0-.803 3.21-8.425-.402-12.037m-21.665-1.608s-2.809 7.624-.801 14.043m21.269-7.22s-4.414 1.202-6.421 3.21m-12.448-2.02c0-.4 4.815-1.203 6.42 1.606",
    stroke: "#7d6c00",
    strokeWidth: 2.369,
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.324 321.97c.204.103 3.995-.717 3.995-2.562 1.948-1.23.512-4.713.512-4.713l-3.585-.718-4.92-5.533c-.238-1.707.343-3.311-.716-5.122-3.381.889-5.328 3.722-6.457 6.967.821 1.025.924 2.151 2.461 3.073 1.605.274 2.697-.682 4.2-.408.786 1.366.546 2.528.82 3.791 2.05 1.434 2.46 3.484 3.69 5.225zm-4.407-23.665v-6.558c-1.57-.07-3.143-.137-4.713-.206-.581.991-1.674 1.47-2.358 2.358-1.093.547-2.185 1.092-3.278 1.64 1.366 1.64 3.04 2.561 4.099 3.38 2.391.718 4.372.718 6.25-.614zm-14.764 9.736l-2.562-4.305c1.57-.512 3.552-.307 5.02.308 0 0 1.13 2.665.308 3.688-.41.922-2.87.513-2.766.31zm38.945 4.406c1.367-.682 2.63-1.878 2.87-3.585l-4.714-5.431-4.303-.102c-.99-1.025-2.596-1.23-3.893-1.23 0 0 1.333 2.05 3.074 2.46 1.23 2.764 6.558 7.888 6.966 7.888zm4.62.604c0-.1 4.2-1.536 6.454-1.33-.204-1.743 3.177-5.74 3.177-5.74l5.943 7.788c-1.092.922-3.006.615-4.51.922 0 0-2.868 2.767-3.176 2.87s-5.532 1.33-8.094-.205c-1.127-2.151.307-4.612.206-4.305zm3.375-13.627c.718-2.493.922-4.987 0-8.095 0 0-6.764-.103-6.764 0 0 .102-4.507 2.049-4.507 2.152s1.436 4.406 3.177 3.996c.785 2.288 3.107 1.707 4.2 2.562 1.299-.204 2.596-.41 3.894-.615zm26.544-6.858c-.922 2.836-1.434 5.876-.103 8.608 1.23.204 2.665 1.024 3.792.82l5.431-9.838c-3.758-1.196-6.798-1.06-9.12.41z",
    fillRule: "evenodd",
    fill: "#c76e2e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M291.307 206.059c-12.811-4.142 2.994-12.425 5.618 0 4.145.67 4.682 3.745 13.642 2.409 21.667 35.308 5.618 92.283-57.778 151.266 113.55-96.631 67.404-168.106 35.96-165.41-17.103 1.168-8.475 22.501 2.558 11.735z",
    fillRule: "evenodd",
    fill: "#b97700"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M292.604 303.635c-.204 0-3.278 2.253-3.278 2.253-1.469.58-2.937 1.162-4.406 1.743l-4.713.1-1.026-3.277 3.588-3.177c-3.04-.444-6.08.752-8.506 2.973 0 0 0 3.585 2.05 5.328 1.23 1.535 4.816 4.303 4.816 4.303 2.254.444 4.406.068 5.84-1.128l5.635-9.118zm-24.802 32.175c1.538.411 12.092-13.626 12.092-13.626-.922-2.63-2.973-4.543-5.227-5.74 0 0-5.124 6.045-5.225 8.096-.82 1.844-3.175 8.913-2.152 9.837-.103.204-.512 3.072.512 1.434z",
    fillRule: "evenodd",
    fill: "#c76e2e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M198.777 338.547c-15.804-13.746-37.128-21.324-66.895-11.04 8.01 3.464 16.67 4.655 24.03 8.442l42.865 2.598z",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeWidth: 2.369,
    fill: "#006800"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.991 328.793c31.174.648 40.267 8.441 38.643 7.142",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.221,
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M199.416 340.164c-9.31 1.839-22.19 10.83-25.978 10.39-10.176-1.183-19.685-5.307-29.55-8.443-4.1-1.302-8.228 0-12.341 0 34.963-16.56 46.87-14.288 67.87-1.947z",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeWidth: 2.221,
    fill: "#006800"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M176.373 315.805s-11.69 1.622-16.886 1.948c-5.197-.324-12.751-5.165-21.107-13.964-4.362-4.777-14.289-4.221-14.289-4.221 21.975-4.655 39.075-.217 52.282 16.237zm-15.92-22.724c-15.913-.975-35.722-15.262-40.267-32.147-.001.215 5.844 3.68 4.87 4.546 26.088 6.602 27.82 11.906 35.397 27.601zm26.633 27.273c2.273-14.397 2.923-23.922-3.896-32.473-5.629-6.496-7.036-10.392-11.04-19.485-1.191 18.943-5.306 34.638 14.936 51.958zm-25.016-39.941c11.797-17.21 13.855-30.2 12.014-50.659-.325 1.624-4.221 11.691-4.545 11.691-17.536 11.04-9.741 28.253-7.469 38.968z",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeWidth: 2.369,
    fill: "#006800"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M151.694 197.282c11.798 17.21 9.959 33.448 8.118 53.906-.325-1.623-4.221-11.69-4.545-11.69-17.536-11.04-5.845-31.501-3.573-42.216z",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeWidth: 2.369,
    fill: "#006800"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M161.43 223.914c28.577-14.396 17.535-32.69 22.732-46.76-19.809 14.721-22.406 30.415-22.731 46.76z",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeWidth: 2.369,
    fill: "#006800"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M165.322 220.343c3.573-10.067 10.717-27.278 11.365-27.278m-19.805 48.385c-.648-7.146-4.22-26.305-4.545-28.253",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.221,
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M158.18 273.59c-15.915-.975-33.126-22.73-37.67-39.616-.002.215 5.843 3.68 4.87 4.547 22.84 10.173 25.222 19.375 32.8 35.07zm-4.727-14.941c-11.797-17.211-13.854-30.2-12.014-50.66.325 1.625 4.222 11.691 4.545 11.691 17.536 11.04 9.742 28.254 7.47 38.969zm10.572-30.186c29.55-13.098 20.457-26.844 29.225-41.241-19.809 14.722-28.9 24.895-29.225 41.24z",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeWidth: 2.369,
    fill: "#006800"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M165.322 225.531c12.015-12.016 16.237-22.082 16.237-22.082",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.221,
    fill: "none"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.449 390.764l14.39.293c-47.773-44.737-139.303-64.217-126.576-146.545-13.118 89.279 74.79 97.501 112.186 146.252z",
    stroke: "#e9bf00",
    strokeWidth: 2.369,
    fill: "#ffe100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.766 226.828a4.584 4.584 0 1 1-9.169 0 4.584 4.584 0 0 1 9.169 0zm-2.807 25.212a4.33 4.33 0 1 1-8.66 0 4.33 4.33 0 0 1 8.66 0zm4.068 35.924a3.82 3.82 0 1 1-7.64 0 3.82 3.82 0 0 1 7.64 0zm33.361 39.727a3.82 3.82 0 1 1-7.64 0 3.82 3.82 0 0 1 7.64 0zm4.838 11.396a3.82 3.82 0 1 1-7.64 0 3.82 3.82 0 0 1 7.64 0z",
    stroke: "#68300e",
    strokeWidth: 1.11,
    fill: "#9d4916"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.07 372.287c-2.513-2.276-4.11-3.737-5.096-6.217l-14.98-1.63c-.067 2.854-.135 5.706-.204 8.559l20.28-.712z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M112.323 362.195c8.7 1.606 21.82-.803 26.103 4.818 5.143 5.83-16.099 14.797-13.057 19.839 6.57 6.952 13.332 4.086 20.686.242 1.732-3.758 3.07-10.458 4.017-12.45-2.677-6.158-9.87-9.175-8.032-18.474 12.13-4.532 35.445-4.157 37.955-2.41 1.97 3.865.2 5.626.6 8.705-2.007 3.882-7.175 10.463-7.186 13.945 12.725 4.483 16.08-.69 27.527-.387 13.412.165 21.572 3.767 24.484-1.565-1.995-4.602-14.297-.858-18.966-3.815-2.335-.79-3.843-2.667-5.861-4.737s-7.692-2.174-8.541-7.27c2.374-10.895 18.096-9.23 20.667-10.898l40.963 2.81c7.421-.209 11.618 13.145 1.597 17.164-10.02 4.017-39.657-5.961-52.513.897-.665-2.797-9.902-7.027-10.568-7.16-3.936 1.178-11.606.746-11.606.746-1.874 3.48-4.013 6.028-5.888 9.509-8.507-3.73-16.548 2.896-25.838.933 0 0-14.056 1.606-14.457 1.606s-9.236-.803-9.236-.803c-4.685 1.337-9.37 2.677-14.055 4.015 3.346-2.946 6.693-5.89 10.038-8.836l-8.833-6.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.703 360.47a3.872 3.872 0 1 1-7.744 0 3.872 3.872 0 0 1 7.744 0zm-1.015 19.154a3.872 3.872 0 1 1-7.744 0 3.872 3.872 0 0 1 7.744 0z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.987 372.356c2.513-2.276 4.11-3.736 5.096-6.217l14.98-1.629c.067 2.853.134 5.705.204 8.558l-20.28-.712z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M393.734 362.264c-8.7 1.606-21.82-.803-26.103 4.819-5.144 5.83 16.099 14.796 13.057 19.838-6.57 6.953-13.333 4.087-20.686.242-1.733-3.758-3.07-10.458-4.017-12.45 2.677-6.157 9.87-9.174 8.032-18.473-12.13-4.533-35.445-4.158-37.956-2.41-1.97 3.865-.199 5.625-.6 8.704 2.008 3.882 7.176 10.463 7.187 13.946-12.725 4.482-16.08-.691-27.527-.388-13.412.166-21.572 3.767-24.484-1.565 1.995-4.602 14.297-.858 18.966-3.814 2.334-.791 3.843-2.667 5.861-4.737s7.691-2.175 8.54-7.27c-2.373-10.895-18.095-9.23-20.666-10.899l-40.963 2.811c-7.422-.21-11.618 13.144-1.598 17.163 10.02 4.017 39.658-5.96 52.514.897.665-2.796 9.902-7.027 10.568-7.16 3.935 1.178 11.605.746 11.605.746 1.875 3.48 4.014 6.029 5.888 9.51 8.507-3.73 16.549 2.895 25.839.932 0 0 14.055 1.606 14.457 1.606s9.235-.803 9.235-.803c4.685 1.338 9.37 2.678 14.056 4.015L384.9 368.69l8.834-6.425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.353 360.54a3.872 3.872 0 1 0 7.745 0 3.872 3.872 0 0 0-7.745 0zm1.016 19.154a3.872 3.872 0 1 0 7.744 0 3.872 3.872 0 0 0-7.744 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.77 351.286c-3.446-.647-4.672-.462-7.008-.693-1.829 5.622-3.655 11.243-5.483 16.864 8.468.764 16.308.764 16.308.695-5.136-1.041-3.886-16.797-3.816-16.866z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontSize: 9,
    fontFamily: "Trebuchet MS",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    y: 344.274,
    x: 448.605,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 344.274,
    x: 448.605
  }, "L")), /*#__PURE__*/React.createElement("text", {
    y: 344.622,
    x: 453.64,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 344.622,
    x: 453.64
  }, "I")), /*#__PURE__*/React.createElement("text", {
    y: 345.056,
    x: 456.678,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 345.056,
    x: 456.678
  }, "B")), /*#__PURE__*/React.createElement("text", {
    y: 345.49,
    x: 462.58,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 345.49,
    x: 462.58
  }, "E")), /*#__PURE__*/React.createElement("text", {
    y: 345.576,
    x: 468.309,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 345.576,
    x: 468.309
  }, "R")), /*#__PURE__*/React.createElement("text", {
    y: 345.403,
    x: 473.952,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 345.403,
    x: 473.952
  }, "T")), /*#__PURE__*/React.createElement("text", {
    y: 344.535,
    x: 479.247,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 344.535,
    x: 479.247
  }, "A")), /*#__PURE__*/React.createElement("text", {
    y: 344.274,
    x: 485.497,
    transform: "translate(-581.23 -248.83) scale(1.7767)"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 344.274,
    x: 485.497
  }, "S")))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M161.43 339.844c10.718 1.299 25.656.323 32.15-.002m-48.388-36.705c9.093 7.144 28.901 11.364 28.576 11.364m11.364 1.962c-2.923-14.937-6.169-18.51-8.766-27.928m-46.436-16.899c15.263 6.82 17.536 11.364 27.277 18.183m5.521-14.931c1.3-18.512 3.898-23.383 8.444-27.605m-41.242-2.261c5.522 6.17 23.706 25.328 23.706 25.328m-7.467-42.225c6.82 4.87 6.82 22.404 6.82 22.404",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.221,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.2feea9ac84e5060ce32b52152b7c3ce8.svg";
export { ForwardRef as ReactComponent };